// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Redu... Remove this comment to see the full error message
import NotificationList from 'ReduxMessenger/components/NotificationList';
import { FloatingAlertList } from 'foundations-components/transitional/components/FloatingAlertList';
import ErrorBoundary from '../components/ErrorBoundary';
import Page from '../components/Page';
import StageSiteSettings from './StageSiteSettings';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Application = ({
  children
}) => {
  return /*#__PURE__*/_jsxs(Page, {
    children: [/*#__PURE__*/_jsx(NotificationList, {}), /*#__PURE__*/_jsx(FloatingAlertList, {}), /*#__PURE__*/_jsx(StageSiteSettings, {}), /*#__PURE__*/_jsx(ErrorBoundary, {
      children: children
    })]
  });
};
export default Application;